import React, { Component } from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
//import ScrollMenu from '../../../components/Widgets/ScrollMenu/scrollMenu.tsx'
import WrapSingleMovie from './SingleMovie.js';
import axios from 'axios';
import * as common from '../../../common.js';
import { isMobile } from 'react-device-detect';
import LoadingOverlay from 'react-loading-overlay';

import IconButton from '@material-ui/core/IconButton';
import { Swipeable } from 'react-swipeable';
import InfiniteScroll from 'react-infinite-scroller';



const RIGHT = '-1';
const LEFT = '+1';
const SEARCHYEAR = 1970;
const SEARCHRATING = 3;
const MAXTITLES = 1000;
const TITLESBLOCK = 50;
const TITLESADD = 10;

Math.seededRandom = function(max, min, seed) {
  max = max || 1;
  min = min || 0;

  seed = (seed * 9301 + 49297) % 233280;
  var rnd = seed / 233280.0;

  return min + rnd * (max - min);
}

function shuffleArray(array,seed) {
  for (let i = array.length - 1; i > 0; i--) {
      //const j = Math.floor(Math.random() * (i + 1));
      const j = Math.floor(Math.seededRandom(1,0,seed) * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
  return array
}
  

const Arrow = ({ text, className }) => {
  return <div className={className}>{text}</div>;
};

const ArrowRightSVG = ({ size, className }) => {
  return (
    <div className={className}>
      <svg height="16" width="16">
        <polygon points="0,0 16,8 0,16" fill="darkgrey" />
      </svg>
    </div>
  );
};

const ArrowLeftSVG = ({ size, className }) => {
  return (
    <div className={className}>
      <svg height="16" width="16">
        <polygon points="16,0 0,8 16,16" fill="darkgrey" />
      </svg>
    </div>
  );
};

function ArrowLeftSVGF() {
  return (
    <div className={'arrow-prev'}>
      <svg height="16" width="16">
        <polygon points="16,0 0,8 16,16" fill="darkgrey" />
      </svg>
    </div>
  );
}

function ArrowRightSVGF() {
  return (
    <div className={'arrow-prev'}>
      <svg height="16" width="16">
        <polygon points="0,0 16,8 0,16" fill="darkgrey" />
      </svg>
    </div>
  );
}

const styles = theme => ({
  horizontalScroll: {
    overflowY: 'scroll',
    overflowX: 'scroll',
    overflow: 'scroll',
    zIndex: 0,
    scrollBehavior: 'smooth',
  },
});

const persistSyntheticEvent = (func, persist) => {
  return (e, ...rest) => {
    if (persist && e.persist) e.persist();
    return func(e, ...rest);
  };
};



//const ArrowLeft = Arrow({ text: "<", className: "arrow-prev" });
//const ArrowRight = Arrow({ text: ">", className: "arrow-next" });
const ArrowLeft = ArrowLeftSVG({ size: 100, className: 'arrow-prev' });
const ArrowRight = ArrowRightSVG({ size: 100, className: 'arrow-next' });

class List extends Component {
  constructor(props) {
    super(props);
    this.menu1 = null;
    this.mounted = false;
    this.showMovieInfoPrevious = false;
  }

  state = {
    themovies: [],
    movie: {},
    showInProcess: false,
    loading: false,
    lastItemVisible: false,
    firstItemVisible: false,
    inertiascrolling: true,
    slowdownFactor: 0.75,
    titleCount: TITLESBLOCK,
    searchYear: SEARCHYEAR,
    searchRating: SEARCHRATING,
    pendingRightShift: false,
    reachedLastTitle: false,
    totalTitlesFetched: 0,
    newSearch: false,
    swipeDirection: 'none',
    persistEvent: true,
    hasMoreItems: false
  };

  //this.SearchTitle(this.state.searchYear,this.state.searchRating,20,title,false,true)
  SearchTitle = (searchYear, searchRating, title, filterChoices, titleCount, lazyLoad, newSearch, seed, region,genres) => {
    //console.log('Browse, List.js: newSearch: ', newSearch);
    //console.log('Browse, List.js: lazyload: ', lazyLoad);
    //console.log('List.js: SearchTitle: ', filterChoices, filterChoices['locklanguage']);

    var newTotalTitlesFetched;
    var movieData = [];
    this.setState({ loading: true });

    var genreKeyWords = []
    var keywords
    genres.map(g => {
      keywords = common.genreMapping[g]
      genreKeyWords.push(keywords)
    })
   

    var apistr = '';
    //&rating=${searchRating}
    if (this.props.type == 'movie') {

      var filterChoice_verified = 0
      if (filterChoices['verified'])
        var filterChoice_verified=1
     
      apistr = `${common.DJANGOURL}/api/moviegenresadmin/?startyear=${filterChoices['startyear']}&endyear=${filterChoices['endyear']}
      &count=${titleCount}&genre=${genreKeyWords}&tmdbrating=${filterChoices['rating']}
      &blockedwords=${filterChoices['blockedwords']}&ageratings=${filterChoices['ageratings']}&country=${region}
      &verifiedWords=${filterChoice_verified}`;

      if (filterChoices['locklanguage'])
        apistr = apistr.concat(`&olanguage=${filterChoices['original_language']}`)
      if (!filterChoices['excludeBlasphemy'])
        apistr = apistr.concat(`&blasphemy=${filterChoices['blasphemy']}`)
      if (!filterChoices['excludeProfanity'])
        apistr = apistr.concat(`&profanity=${filterChoices['profanity']}`)
      if (!filterChoices['excludeSexual'])
        apistr = apistr.concat(`&sexual=${filterChoices['sexual']}`)
      if (!filterChoices['excludeRacial'])
        apistr = apistr.concat(`&racial=${filterChoices['racial']}`)
      if (filterChoices['netflix'])
        apistr = apistr.concat(`&netflix=1`)
      if (filterChoices['autoModified'])
        apistr = apistr.concat(`&autoModified=1`)
      if (filterChoices['christian'])
        apistr = apistr.concat(`&christian=1`)
    
      console.log('List.js: apistr = ', apistr, filterChoices)
      //apistr = common.DJANGOURL+ '/api/moviegenres/?year=1960&rating=4&genre=' + this.props.title;
    } else {
      apistr = `${common.DJANGOURL}/api/tvgenres/?startyear=${filterChoices['startyear']}&endyear=${filterChoices['endyear']}
      &count=${titleCount}&genre=${genreKeyWords}&tmdbrating=${filterChoices['rating']}
      &blockedwords=${filterChoices['blockedwords']}&ageratings=${filterChoices['ageratings']}&country=${region}`;

      
      if (filterChoices['locklanguage'])
        apistr = apistr.concat(`&olanguage=${filterChoices['original_language']}`)
      if (!filterChoices['excludeBlasphemy'])
        apistr = apistr.concat(`&blasphemy=${filterChoices['blasphemy']}`)
      if (!filterChoices['excludeProfanity'])
        apistr = apistr.concat(`&profanity=${filterChoices['profanity']}`)
      if (!filterChoices['excludeSexual'])
        apistr = apistr.concat(`&sexual=${filterChoices['sexual']}`)
      if (!filterChoices['excludeRacial'])
        apistr = apistr.concat(`&racial=${filterChoices['racial']}`)
      if (filterChoices['netflix'])
        apistr = apistr.concat(`&netflix=1`)


      //apistr = `${common.DJANGOURL}/api/tvgenres/?year=${searchYear}&count=${titleCount}&genre=${title}`;
      //apistr = common.DJANGOURL+ '/api/tvgenres/?year=1960&rating=4&genre=' + this.props.title;
    }

    axios
      .get(apistr)
      .then(res => {
        if (this.mounted) {
          movieData = res.data;
          //movieData = res.data;

          newTotalTitlesFetched = movieData.length;

          console.log('Lists.js  newTotalTitlesFetched', newTotalTitlesFetched);
          console.log('Lists.js  state.TitlesFetched', this.state.totalTitlesFetched);
          //console.log('Lists.js , SearchTitle: newSearch: ', newSearch);
          if (newTotalTitlesFetched != this.state.totalTitlesFetched || newSearch) {
            if (newSearch) {
              this.setState({
                reachedLastTitle: false,
                hasMoreItems: true,
                themovies: movieData,
                loading: false,
                pendingRightShift: false,
                totalTitlesFetched: newTotalTitlesFetched,
                titleCount: TITLESBLOCK,
                newSearch: true,
              });
            } else {
              this.setState({
                newSearch: false,
                reachedLastTitle: false,
                hasMoreItems: true,
                themovies: movieData,
                loading: false,
                pendingRightShift: false,
                totalTitlesFetched: newTotalTitlesFetched,
              });
            }
            //this.renderRedirect();
          } else {
            console.log('List.js: reached end')
            this.setState({ loading: false, pendingRightShift: false, reachedLastTitle: true, hasMoreItems: false });
          }
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        //console.log('Browse: Get DB Error');
      });

    /*
    const url =
      typeof this.props.apiCall === "number"
        ? `https://api.themoviedb.org/3/discover/movie?api_key=17117ab9c18276d48d8634390c025df4&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=1&with_genres=${
            this.props.apiCall
          }`
        : `https://api.themoviedb.org/3/movie/${this.props.apiCall}?api_key=17117ab9c18276d48d8634390c025df4&language=en-US&page=1`;

    fetch(url)
      .then(r => r.json())
      .then(data => {
        if (this.mounted) this.setState({ movies: data.results });
      })
      .catch(err => //console.log(err)); */
  };

  componentDidMount() {
    //console.log('List.js component mount')
    this.mounted = true;
    this.showMovieInfoPrevious = this.props.showMovieInfo;
    this.SearchTitle(
      this.state.searchYear,
      this.state.searchRating,
      'Admin filtered Movies',
      this.props.filterChoices,
      TITLESBLOCK,
      false,
      true,
      this.props.movieShuffleSeed,
      this.props.region,
      this.props.genres
    );
  }

  componentWillUnmount() {
    //console.log('List.js component unmount')
    this.mounted = false;
  }

  LeftArrowProcess = () => {
    setTimeout(() => {
      var newLastVisible = this.menu1.checkFirstLastItemVisibility({})['lastItemVisible'];
      this.setState({ lastItemVisible: newLastVisible });
    }, 500);
  };

  TitlesClickLeftArrow = () => {
    //console.log('Search: Titlesclickleftarrow')
    //console.log('Search: Met condition Titlesclickleftarrow')
    this.menu1.handleArrowClick();
    this.LeftArrowProcess();
  };

  

  TitlesClickRightArrow = () => {
    //console.log'List.js: Titlesclickrightarrow: ', this.menu1)
    //console.log('Search: Met condition Titlesclickleftarrow')
    this.menu1.handleArrowClickRight();
    this.RightArrowProcess();
  };

  componentDidUpdate() {
    if (this.state.pendingRightShift) {
      this.TitlesClickRightArrow();
      this.setState({ pendingRightShift: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    //console.log'List.js shouldComponentUpdate', this.mounted, nextState.themovies,this.state.themovies );
    if (this.mounted) return true;
    /*if (this.state.themovies === nextState.themovies) {
      return false;
    } else {
      return true;
    }*/
  }

  buildBlankMovie = index => {
    var rtime1 = Math.floor(Math.random() * 10) + 1;
    var strrtime1 = rtime1.toString() + 's';
    return (
      <div className="menu-item" key={index}>
        <svg width="150" height="225" viewBox="0 0 150 225">
          <rect width="150" height="225" rx="10" ry="10" fill="url(#skyGradient)" />
          <linearGradient id="skyGradient" x1="100%" y1="100%">
            <stop offset="100%" stopColor="lightblue" stopOpacity="1">
              <animate
                attributeName="stop-color"
                values="#111111;#222222;#111111"
                dur="2s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </svg>
      </div>
    );
  };

  onSwiped(direction) {
    if (direction === LEFT) {
      this.setState({ swipeDirection: 'Right' });
      this.RightArrowProcess();
    } else {
      this.setState({ swipeDirection: 'Left' });
      this.LeftArrowProcess();
    }
  }

  onSwipedDirection(direction) {
    this.setState({
      swipeDirection: direction,
    });
  }

  onSwiping(args) {
    if (args.dir == 'Left') {
      this.RightArrowProcess();
      this.setState({ swipeDirection: 'Left' });
    } else {
      this.LeftArrowProcess();
      this.setState({ swipeDirection: 'Right' });
    }
  }

  loadItems(page) {
    var self = this;

    var lazyload, newTitleCount, newSearch;

    if (this.state.hasMoreItems && !this.state.loading) {
      console.log('Search Generic Load more items')
      newTitleCount = this.state.titleCount + TITLESADD;
      this.setState({
        loading: true,
        titleCount: newTitleCount,
      
      });
      newSearch = false;

      this.SearchTitle(
        this.state.searchYear,
            this.state.searchRating,
            'Admin filtered Movies',
            this.props.filterChoices,
            newTitleCount,
            true,
            newSearch,
            this.props.movieShuffleSeed,
            this.props.region,
            this.props.genres
      )   
      
    }
  }


  render() {
    const { persistEvent, loading } = this.state;
    const loader = <div className="loader">Loading ...</div>;

    //console.log('List.js shuffle: ', this.props.movieShuffleSeed)
    //console.log('List.js movies: ', this.props.filterChoices)
    //console.log('List: netflix region: ', this.props.region)
    const mlen = this.state.themovies.length;
    const movieEmpty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    var movieData = [];

    const movieFull = this.state.themovies.map((movie, index) => {
      if (movie) {
        if (index == mlen - 1) {
          //console.log('List.js reached last movie: ', movie,index)
          return (
            <div className="menu-item-last" key={movie.imdbID}>
              <WrapSingleMovie movie={movie} netflix_region={this.props.region} />
            </div>
          );
        } else {
          return (
            <div className="menu-item" key={movie.imdbID}>
              <WrapSingleMovie movie={movie} netflix_region={this.props.region} />
            </div>
          );
        }
      }
      else
        return (
          <div className="menu-item"></div>
        )
    });

    const movieLoading = movieEmpty.map(index => {
      return this.buildBlankMovie(index);
    });

    //if (this.state.themovies.length > 0)
    //console.log('List.js: movieFull: ', movieFull)
    if (!loading) {
      movieData = movieFull;
      //console.log('List.js: movieData not loading ', movieData)
    } else {
      //movieData = movieLoading;

      if (movieFull.length > 0) movieData = movieFull.concat(movieLoading);
      else movieData = movieLoading;
      //console.log('List.js: movieData loading ', movieData)
    }

    let swipeableDirProps = {};
    swipeableDirProps.onSwiping = persistSyntheticEvent(
      (...args) => this.onSwiping(...args),
      persistEvent,
    );

    /*
          onSwipedLeft={() => this.onSwiped(LEFT)}
          onSwipedRight={() => this.onSwiped(RIGHT)}
         preventDefaultTouchmoveEvent 
         {...swipeableDirProps}
         <h4 style={{marginLeft:'10px', color: 'black' }} >{this.state.swipeDirection}</h4>*/

    return (
      <div>
        {isMobile ? (
          <div style={{ marginTop: '40px' }}>
            <h4 style={{ marginLeft: '10px', color: 'black' }}>{this.props.heading}</h4>

            <Swipeable trackMouse {...swipeableDirProps}>
              <ScrollMenu
                ref={el => {
                  this.menu1 = el;
                }}
                data={movieData}
                wheel={false}
                dragging={true}
                alignCenter={false}
                clickWhenDrag={false}
                innerWrapperStyle={{ display: 'flex', alignItems: 'center' }}
                inertiaScrolling={true}
                inertiaScrollingSlowdown={0.75}
              />
            </Swipeable>
          </div>
        ) : (
          <div style={{ marginTop: '40px' }}>
            <h4 style={{ marginLeft: '50px', color: 'black' }}>{this.props.heading}</h4>

            <InfiniteScroll
                pageStart={0}
                loadMore={this.loadItems.bind(this)}
                hasMore={this.state.hasMoreItems}
                loader={loader}>
                <div className="tiledMovies">
                {movieData}
                </div>
            </InfiniteScroll>

             

          </div>
        )}
      </div>
    );
  }
}

export default List;
